window.tinymce.PluginManager.add('tcolorpicker', function(editor) {
    function colorPickerCallback(callback, value) {
        function generateCode(color) {
            return `rgba(${color.r},${color.g},${color.b},${color.a})`;
        }
        function setColor(value) {
            const matches = /rgba\s*\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*(0*1|0*|0*\.[0-9]*)\s*\)/gi.exec(value);
            let color, rgb, colorCode;
            if (matches) {
                let r = parseInt(matches[1], 10);
                let g = parseInt(matches[2], 10);
                let b = parseInt(matches[3], 10);
                let a = parseFloat(matches[4], 10);
                r = r < 0 ? 0 : (r > 255 ? 255 : r);
                g = g < 0 ? 0 : (g > 255 ? 255 : g);
                b = b < 0 ? 0 : (b > 255 ? 255 : b);
                a = a < 0 ? 0 : (a > 1 ? 1 : a);
                const rgba = {r, g, b, a};
                color = new window.tinymce.util.Color(rgba);
                rgb = rgba;
                colorCode = generateCode(rgba);
            }
            else if (typeof value === 'object' && 'a' in value) {
                color = new window.tinymce.util.Color(value);
                rgb = value;
                colorCode = generateCode(value);
            }
            else {
                color = new window.tinymce.util.Color(value);
                rgb = color.toRgb();
                colorCode = color.toHex();
            }

            win.fromJSON({
                r: rgb.r,
                g: rgb.g,
                b: rgb.b,
                a: rgb.a,
                hex: color.toHex().substr(1),
            });

            showPreview(colorCode);
        }

        function showPreview(hexColor) {
            win.find('#preview')[0].getEl().style.background = hexColor;
        }

        const win = editor.windowManager.open({
            title: 'Color',
            items: {
                type: 'container',
                layout: 'flex',
                direction: 'row',
                align: 'stretch',
                padding: 5,
                spacing: 10,
                items: [
                    {
                        type: 'colorpicker',
                        value,
                        onchange() {
                            const rgb = this.rgb();

                            if (win) {
                                win.find('#r').value(rgb.r);
                                win.find('#g').value(rgb.g);
                                win.find('#b').value(rgb.b);
                                win.find('#t').value(rgb.a);
                                win.find('#hex').value(this.value().substr(1));
                                showPreview(this.value());
                            }
                        },
                    },
                    {
                        type: 'form',
                        padding: 0,
                        labelGap: 5,
                        defaults: {
                            type: 'textbox',
                            size: 7,
                            value: '0',
                            flex: 1,
                            spellcheck: false,
                            onkeyup() {
                                const colorPickerCtrl = win.find('colorpicker')[0];
                                const name = this.name();
                                let value = this.value();

                                if (name === 'hex') {
                                    value = '#' + value;
                                    setColor(value);
                                    colorPickerCtrl.value(value);
                                    return;
                                }

                                value = {
                                    r: win.find('#r').value(),
                                    g: win.find('#g').value(),
                                    b: win.find('#b').value(),
                                    a: win.find('#a').value(),
                                };

                                colorPickerCtrl.value(value);
                                setColor(value);
                            },
                        },
                        items: [
                            {name: 'r', label: 'R', autofocus: 1},
                            {name: 'g', label: 'G'},
                            {name: 'b', label: 'B'},
                            {name: 'a', label: 'Transparency'},
                            {name: 'hex', label: '#', value: '000000'},
                            {name: 'preview', type: 'container', border: 1},
                        ],
                    },
                ],
            },
            onSubmit() {
                callback(generateCode(this.toJSON()));
            },
        });

        setColor(value);
    }

    if (!editor.settings.color_picker_callback) {
        editor.settings['color_picker_callback'] = colorPickerCallback;
    }
});
